import script from "./DashboardTop.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardTop.vue?vue&type=script&setup=true&lang=js"

import "./DashboardTop.vue?vue&type=style&index=0&id=390a3f6e&lang=css"

const __exports__ = script;

export default __exports__